import { AnalyticsEvent } from './BaseAnalyticsEvent';
import { type AnalyticsEventName } from './types/AnalyticsEventName';

export class FavoriteEvent extends AnalyticsEvent<AnalyticsEventName.FAVORITE> {
  constructor(public data: { title: string; url: string }) {
    super('analytics.favorite');
  }
}
